import React from "react";
import useUiController from "../global/hooks/useUiController";
import SnpBaseLayout from "../global/SnpBaseLayout"
import EmployeeSalary from "./EmployeeSalary";

const EmployeeSalaryBase = () => {

    const {
        loader,
        setLoader,
        showSnackbar,
        snackbarConfig,
        closeSnackbar,
        dialogConfig,
        notificationConfig,
    } = useUiController();

    return (
        <SnpBaseLayout
            loader={loader}
            snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
            dialogConfig={dialogConfig}
            notificationConfig={notificationConfig}
        >
            <EmployeeSalary 
                setLoader={setLoader} 
                showSnackbar={showSnackbar}
            />
        </SnpBaseLayout>
    )
}
export default EmployeeSalaryBase;